var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex-1 billing-table-head-item tw-rounded tw-truncate tw-relative",class:{
    right: _vm.right
  }},[_c('span',{staticClass:"tw-px-2 tw-uppercase tw-font-medium tw-text-xs tw-text-secondary tw-truncate",domProps:{"textContent":_vm._s(_vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }